<template>
  <nav class="navigation">
    <router-link class="logo" to="/"><img :src="imageLogo" /></router-link>
    <ul class="menu">
      <li v-if="data.user.token !== ''">
        <router-link to="/play">{{ content('play') }}</router-link>
      </li>
      <li :key="item.name" v-for="item in communication">
        <a target="_blank" :href="item.url">{{ item.name }}</a>
      </li>
    </ul>
    <ul class="account">
      <li v-if="data.user.token === ''">
        <router-link to="/user/create">{{ content('create') }}</router-link>
      </li>
      <li v-if="data.user.token === ''">
        <router-link to="/user/discord">{{ content('login') }}</router-link>
      </li>
      <li v-if="data.user.token !== ''">
        <router-link to="/user">{{ content('profile') }}</router-link>
      </li>
      <li v-if="data.user.token !== ''">
        <a @click="logout">
          {{ content('logoff') }}
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
import logoImage from '@/assets/images/logo.webp';
import config from '@/helpers/config';
import dataStore from '@/helpers/data';
import language from '@/helpers/language';
export default {
  name: 'ComponentCoreHeaderNavigation',
  components: {},
  computed: {
    data() {
      return dataStore.getter(this.$store.getters);
    },
    imageLogo() {
      return logoImage;
    },
  },
  props: {},
  data() {
    return {
      communication: [],
    };
  },
  mounted() {
    this.communication = config.communication;
  },
  updated() {
    this.communication = config.communication;
  },
  methods: {
    content(item) {
      return language(this.data.language.current)[item];
    },
    logout() {
      this.$store.dispatch('user/logout');
    },
  },
};
</script>
